require('./accountSettlementsInfo.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const {FormattedText, getLanguage} = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { FormattedIban } = require('commonsComponents/formattedIban');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class AccountSettlementsInfo extends React.Component {
    render() {
        const {immSettlement, immAccount, isInvestmentCredit} = this.props;
        const plainAmountObject = getPlainAmountObject(immSettlement.get('creditAmount'));
        const plainAmountBalanceObject = getPlainAmountObject(immAccount.get('balance'));
        const language = getLanguage();
        let accountLabel = isInvestmentCredit ? 'investmentCredits-creditNumber' : 'accountSettlementsDetails-accountNumber' ;

        return (
            <OKSectionBox>
                <div className="account-settlements-info__header">
                    <FormattedText
                        className="account-settlements-info__import-label"
                        value="accountSettlementsDetails-import"
                    />
                    <OneLineSymbolAmount
                        className="account-settlements-info__import-value"
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </div>
                <OKInformativeList>
                    <OKInformativeListItem title={accountLabel}>
                        <FormattedIban className="account-settlements-info__value" iban={immAccount.get('iban')} />
                    </OKInformativeListItem>
                    <OKInformativeListItem title="accountSettlementsDetails-holder" bodyText={immAccount.get('accountHolder')} />
                    <OKInformativeListItem title="accountSettlementsDetails-balance" className="account-settlements-info__value--last-one">
                        <OneLineSymbolAmount
                            className="account-settlements-info__value"
                            amountObject={plainAmountBalanceObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountBalanceObject, true)} />
                    </OKInformativeListItem>
                </OKInformativeList>
            </OKSectionBox>
        );
    }
}

AccountSettlementsInfo.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immSettlement: PropTypes.object.isRequired,
    isInvestmentCredit: PropTypes.object
};

module.exports = AccountSettlementsInfo;
